import { BaseEntity } from '../../models';
import { situacaoAtiva } from './situacao';
import { Plataforma } from '../plataforma';
import { IntegracaoFrete } from './frete';
import { IntegracaoPagamento } from './pagamento';
import { IntegracaoEvento } from './evento';
import { IntegracaoClassificacaoCliente } from './classificacao-cliente';
import { IntegracaoCanalVendaEntity } from './canais-venda/domain';

export class Integracao implements BaseEntity {
    readonly id: number;
    idEmpresa: number;
    idPlataforma: number;
    plataforma: Plataforma;
    nome: string;
    descricao: string;
    situacao: number;
    dbHost1: string;
    dbPort1: string;
    dbNameOrPath1: string;
    dbSchema1: string;
    dbUser1: string;
    dbPassword1: string;
    dbHost2: string;
    dbPort2: string;
    dbNameOrPath2: string;
    dbSchema2: string;
    dbUser2: string;
    dbPassword2: string;
    url: string;
    consumerKey: string;
    consumerSecrect: string;
    idClienteTipo: number;
    idRepresentante: number;
    idCidadeExterior: number;
    fretes: IntegracaoFrete[];
    pagamentos: IntegracaoPagamento[];
    eventos: IntegracaoEvento[];
    canaisVenda: IntegracaoCanalVendaEntity[];

    /** Pessoas */
    integrarPessoaDataFundacao: boolean;
    integrarPessoaDataCadastro: boolean;
    integrarPessoaSite: boolean;
    integrarPessoaComplemento: boolean;
    integrarPessoaInscricaoMunicipal: boolean;
    integrarPessoaInscricaoSuframa: boolean;
    integrarPessoaInscricaoProdutorRural: boolean;
    integrarPessoaNomeContato: boolean;
    integrarPessoaCelularContato: boolean;
    integrarPessoaEmailContato: boolean;

    /** Clientes */
    apiResourceCliente: string;
    regraOrigemInserirCliente: number;
    origemInserirCliente: number;
    idCampanhaInserirCliente: number;
    canalMidiaSocialInserirCliente: number;
    integrarClienteCadastro: boolean;
    integrarClienteClassificacaoFaturamento: boolean;
    integrarClienteOptanteSimplesNacional: boolean;
    integrarClienteIsentoIpi: boolean;
    integrarClienteAnotacao: boolean;
    integrarClienteExigeOrdemCompraComXML: boolean;
    integrarClienteLaudo: boolean;
    integrarClienteEmailLaudo: boolean;
    integrarClienteEmailAprovacaoCliche: boolean;
    integrarClienteEmailNfe: boolean;
    integrarClienteEmailBoleto: boolean;
    integrarClientePreferenciasVencimentos: boolean;
    integrarClienteAnotacaoAnaliseFinanceira: boolean;
    revisarClienteCadastroNovo: boolean;
    idPeriodicidadeCompraInserirCliente: number;
    // Classificações
    integrarClassificacoesCliente: boolean;
    classificacoesClienteNome: string;
    classificacoesCliente: IntegracaoClassificacaoCliente[];
    idTipoClassificacaoTipoClienteERP: number;
    idTipoClassificacaoGrupoClienteERP: number;

    /** Representantes */
    integrarRepresentanteModalidadeComercial: boolean;
    integrarRepresentanteTipoComissao: boolean;
    integrarRepresentantePercComissao: boolean;
    integrarRepresentanteAnotacao: boolean;

    /** Itens Tipos */
    integrarItemTipoSituacao: boolean;

    /** Unidades Negócios */
    integrarUnidadeNegocioSituacao: boolean;

    /** Linhas Produções  */
    integrarLinhaProducaoSituacao: boolean;

    /** Naturezas Vendas */
    integrarNaturezaVendaSituacao: boolean;

    /** Itens */
    integrarItemSituacao: boolean;
    integrarItemDataCadastro: boolean;
    integrarItemPessoa: boolean;
    integrarItemItemUnidade: boolean;
    integrarItemGrupoRentabilidade: boolean;
    integrarItemItemGrupo: boolean;
    integrarItemItemSubGrupo: boolean;
    integrarItemItemFamilia: boolean;
    integrarItemItemLinha: boolean;
    integrarItemItemMarca: boolean;
    integrarItemItemTipo: boolean;
    integrarItemUnidadeNegocio: boolean;
    integrarItemLinhaProducao: boolean;
    integrarItemNaturezaVenda: boolean;
    integrarItemMercado: boolean;
    integrarItemQuantidadeCaixaEmbarque: boolean;
    integrarItemPercComissao: boolean;
    integrarItemCustoVariavel: boolean;
    integrarItemCustoFixo: boolean;
    integrarItemDespesaOperacional: boolean;
    integrarItemIpi: boolean;
    integrarItemFatorConversao: boolean;
    integrarItemClassificacoes: boolean;
    integrarItemPesoBruto: boolean;
    integrarItemPesoLiquido: boolean;

    /** Formas de Pagamentos */
    integrarFormaPagamentoSituacao: boolean;

    /** Condições de Pagamentos */
    integrarCondicaoPagamentoSituacao: boolean;
    integrarCondicaoPagamentoFormaPagamento: boolean;
    integrarCondicaoPagamentoPrazoMedio: boolean;
    integrarCondicaoPagamentoQuantidadeParcelas: boolean;
    integrarCondicaoPagamentoMultiplo: boolean;
    integrarCondicaoPagamentoPrazoInicial: boolean;
    integrarCondicaoPagamentoPercTaxaFinanceiro: boolean;

    /** Mercados */
    integrarMercadoSituacao: boolean;

    /** Pedidos */
    idTabelaPrecoPedido: number;
    referenciaLocalFaturamentoPedido: number;
    integrarPedidoLocalFaturamento: boolean;
    idLocalFaturamentoPedido: number;
    gerarPedidoGratuito: boolean;
    tipoVendaPedidoGratuito: number;
    idTabelaPrecoPedidoGratuito: number;
    idCampanhaPedidoGratuito: number;
    integrarPedidoPrazoMedio: boolean;
    integrarPedidoPrazosPagamento: boolean;
    integrarPedidoCampanha: boolean;
    integrarPedidoPessoaContaOrdem: boolean;
    integrarPedidoNumeroPedidoCliente: boolean;
    integrarPedidoTabelaPreco: boolean;
    integrarPedidoCuponsDesconto: boolean;
    integrarPedidoPercDesconto: boolean;
    integrarPedidoPercDescontoMedio: boolean;
    integrarPedidoResponsavelCliente: boolean;
    integrarPedidoResponsavelEmpresa: boolean;
    integrarPedidoTipoPagamento: boolean;
    integrarPedidoCondicaoPagamento: boolean;
    integrarPedidoFormaPagamento: boolean;
    integrarPedidoQuantidadeVolumesPrevistos: boolean;
    integrarPedidoPesoBruto: boolean;
    integrarPedidoPesoLiquido: boolean;
    integrarPedidoCanalVenda: boolean;
    canalVendaPedido: boolean;
    integrarPedidoTipoFrete: boolean;
    tipoFretePedido: number;
    integrarPedidoTransportadora: boolean;
    integrarPedidoValorFrete: boolean;
    integrarPedidoPaletizacao: boolean;
    integrarPedidoAplicaClausulaReajuste: boolean;
    integrarPedidoPrecoFixoAte: boolean;
    itegrarPedidoAnotacao: boolean;
    integrarPedidoIcms: boolean;
    integrarPedidoIpi: boolean;
    integrarPedidoFilho: boolean;
    integrarPedidoResultadoLiquido: boolean;
    integrarPedidoSetorGep: boolean;
    /** Pedido Item **/
    integrarPedidoItemTabelaPreco: boolean;
    integrarPedidoItemCoeficiente: boolean;
    integrarPedidoItemDestinacaoProduto: boolean;
    integrarPedidoItemPercComissao: boolean;
    integrarPedidoItemEntregas: boolean;
    gerarComissoesPedidoItens: boolean;

    constructor() {
        this.situacao = situacaoAtiva.id;
        this.fretes = [];
        this.pagamentos = [];
        this.eventos = [];
        this.classificacoesCliente = [];
        this.canaisVenda = [];
    }
}
